import React, { Component, cloneElement, useState } from "react";
import {
  List,
  CreateButton,
  RefreshButton,
  TopToolbar,
  Datagrid,
  TextField,
  DateField,
  ShowButton,
  Filter,
  TextInput,
  SelectInput,
  usePermissions,
  DateInput,
} from "react-admin";

import { Scrollbars } from "react-custom-scrollbars";
import Spinner from "../spinner";
import myDataProvider from "../myRestProvider";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import Modal from "react-responsive-modal";

const selectInputStyle = {
  width: 200,
};

const InAppFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Purpose" source="purpose" />
    <DateInput source="from_date" label="Uploaded date from" />
    <DateInput source="to_date" label="Uploaded date to" />
  </Filter>
);

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const textFieldStyle = {
  display: "block",
  width: 200,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const ListActions = ({
  resource,
  basePath,
  filterValues,
  total,
  maxResults,
  currentSort,
  exporter,
  permanentFilter,
  showFilter,
  displayedFilters,
  filters,
}) => {
  return (
    <TopToolbar>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: "button",
        })}
      <CreateButton basePath={basePath} />
      <RefreshButton />
    </TopToolbar>
  );
};

const BulkSendMessageList = (props) => {
  const [modalShow, setModalShow] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const permissions = usePermissions();

  const exporter = (data) => {
    const msg = data[0].message;
    setModalShow(true);
    setModalMsg(msg);
  };

  const onClose = () => {
    setModalShow(false);
  };

  return (
    <React.Fragment>
      <Scrollbars className="scroll-container">
        <List
          exporter={exporter}
          sort={{ field: "created_at", order: "DESC" }}
          filters={<InAppFilter />}
          title="Send Bulk Message"
          actions={<ListActions permissions={permissions} />}
        >
          <Datagrid rowClick="show" bulkActionButtons={false}>
            <TextField
              label="Purpose"
              source="purpose"
              style={textFieldStyle}
              allowEmpty
            />
            <TextField
              label="Target type"
              source="target_type"
              sortable={false}
              allowEmpty
            />
            {/* <TextField label="Creator Email" source="admin_email" /> */}
            {/* <DateField label={'Created at'} source="created_at" allowEmpty /> */}
            <DateField label="Created At" source="created_at" showTime />
            <ShowButton />
          </Datagrid>
        </List>
      </Scrollbars>
      {modalShow && (
        <Modal open={modalShow} onClose={onClose} center>
          <h3>{modalMsg}</h3>
        </Modal>
      )}
    </React.Fragment>
  );
};

export default BulkSendMessageList;
